import { createReducer } from 'deox';
import { produce } from 'immer';

import {
  setRegisterData,
  setClinicRegisterData,
  prevRegisterStep,
  nextRegisterStep,
  getStripePrices,
  setCurrentStripePrice,
  login,
  register,
  clearAuthError,
  setItSystem,
  setBillingType,
  confirmEmail,
  setRefreshToken,
  setAccessToken,
  signupSubClinic,
  setAccessTokenForSubClinic,
  setOpenNewWindows,
  forgotPassword,
  createNewPassword,
  setTemporary,
} from './actions';
import { AuthTypes } from './types';

const initialState: AuthTypes = {
  token: '',
  refresh: '',
  loading: false,
  errors: {},
  registerData: {
    howManyCameras: '1',
    howManyCamerasCompany: '6-25',
    howManyClinics: '6-25',
    country: 'Australia',
    billingType: 'Monthly',
    phoneNumber: '',
  },
  registerStep: 1,
  stripePrices: [],
  itSystem: true,
  isActiveAccount: false,
  clinicRegisterData: {
    enterpriseToken: '',
    fullName: '',
    email: '',
    password: '',
    mobileNumber: '',
    companyName: '',
    storeLocation: '',
    storePhone: '',
    country: ''
  },
  openNewWindows: false,
  temporary: false,
};

export const authReducer = createReducer(initialState, handleAction => [
  handleAction(setRegisterData, (state, { payload: { name, value } }) =>
    produce(state, draft => {
      draft.registerData[name] = value;
    }),
  ),
  handleAction(setClinicRegisterData, (state, { payload: { name, value } }) =>
    produce(state, draft => {
      draft.clinicRegisterData[name] = value;
    }),
  ),
  handleAction(prevRegisterStep, state =>
    produce(state, draft => {
      draft.registerStep = draft.registerStep - 1;
    }),
  ),
  handleAction(nextRegisterStep, state =>
    produce(state, draft => {
      draft.registerStep = draft.registerStep + 1;
    }),
  ),
  handleAction(getStripePrices.request, (state, { payload }: any) =>
    produce(state, draft => {
      draft.loading = true;
      draft.errors = {};
    }),
  ),
  handleAction(getStripePrices.success, (state, { payload }: any) =>
    produce(state, draft => {
      draft.loading = false;
      draft.stripePrices = payload;
    }),
  ),
  handleAction(getStripePrices.fail, (state, { payload }: any) =>
    produce(state, draft => {
      draft.loading = false;
      draft.errors = payload;
    }),
  ),
  handleAction(setCurrentStripePrice, (state, { payload }: any) =>
    produce(state, draft => {
      draft.registerData.currentStripePrice = payload;
    }),
  ),
  // REGISTER
  handleAction(register.request, (state, { payload }: any) =>
    produce(state, draft => {
      draft.loading = true;
      draft.errors = {};
    }),
  ),
  handleAction(register.success, state =>
    produce(state, draft => {
      draft.loading = false;
    }),
  ),
  handleAction(register.fail, (state, { payload }: any) =>
    produce(state, draft => {
      draft.loading = false;
      draft.errors = payload;
    }),
  ),
  // LOGIN
  handleAction(login.request, state =>
    produce(state, draft => {
      draft.loading = true;
      draft.errors = {};
    }),
  ),
  handleAction(login.success, (state, { payload }) =>
    produce(state, draft => {
      draft.loading = false;
      draft.token = payload.access;
      draft.refresh = payload.refresh;
    }),
  ),
  handleAction(login.fail, (state, { payload }: any) =>
    produce(state, draft => {
      draft.loading = false;
      draft.errors = payload;
    }),
  ),
  // CLEAR ERROR
  handleAction(clearAuthError, state =>
    produce(state, draft => {
      draft.errors = {};
    }),
  ),
  // SET IT SYSTEM
  handleAction(setItSystem, (state, { payload }) =>
    produce(state, draft => {
      draft.itSystem = payload;
    }),
  ),
  handleAction(setBillingType, (state, { payload }) =>
    produce(state, draft => {
      draft.registerData.billingType = payload;
    }),
  ),
  handleAction(confirmEmail.request, state =>
    produce(state, draft => {
      draft.loading = true;
      draft.errors = {};
    }),
  ),
  handleAction(confirmEmail.success, state =>
    produce(state, draft => {
      draft.loading = false;
      draft.isActiveAccount = true;
    }),
  ),
  handleAction(confirmEmail.fail, (state, { payload }: any) =>
    produce(state, draft => {
      draft.loading = false;
      draft.errors = payload;
    }),
  ),
  handleAction(setRefreshToken, (state, { payload }: any) =>
    produce(state, draft => {
      draft.refresh = payload;
    }),
  ),
  handleAction(setAccessToken, (state, { payload }: any) =>
    produce(state, draft => {
      draft.token = payload;
    }),
  ),
  // SIGNUP SUB CLINIC
  handleAction(signupSubClinic.request, state =>
    produce(state, draft => {
      draft.loading = true;
      draft.errors = {};
    }),
  ),
  handleAction(signupSubClinic.success, state =>
    produce(state, draft => {
      draft.loading = false;
      draft.openNewWindows = true;
    }),
  ),
  handleAction(signupSubClinic.fail, (state, { payload }: any) =>
    produce(state, draft => {
      draft.loading = false;
      draft.errors = payload;
      draft.openNewWindows = false;
    }),
  ),
  // SET ACCESS TOKEN FOR SUB CLINIC
  handleAction(setAccessTokenForSubClinic, (state, { payload }: any) =>
    produce(state, draft => {
      draft.clinicRegisterData['enterpriseToken'] = payload;
    }),
  ),
  handleAction(setOpenNewWindows, (state, { payload }: any) =>
    produce(state, draft => {
      draft.openNewWindows = payload;
    }),
  ),
  // FORGOT PASSWORD
  handleAction(forgotPassword.request, state =>
    produce(state, draft => {
      draft.loading = true;
      draft.errors = {};
    }),
  ),
  handleAction(forgotPassword.success, state =>
    produce(state, draft => {
      draft.loading = false;
    }),
  ),
  handleAction(forgotPassword.fail, (state, { payload }: any) =>
    produce(state, draft => {
      draft.loading = false;
      draft.errors = payload;
    }),
  ),
  // CREATE NEW PASSWORD
  handleAction(createNewPassword.request, state =>
    produce(state, draft => {
      draft.loading = true;
      draft.errors = {};
    }),
  ),
  handleAction(createNewPassword.success, state =>
    produce(state, draft => {
      draft.loading = false;
    }),
  ),
  handleAction(createNewPassword.fail, (state, { payload }: any) =>
    produce(state, draft => {
      draft.loading = false;
      draft.errors = payload;
    }),
  ),
  handleAction(setTemporary, (state, { payload }: any) =>
  produce(state, draft => {
    draft.temporary = payload;
  }),
),
]);
